'use strict'

export function getInsigts(url) {
  const xhr = new XMLHttpRequest()

  return new Promise((res, rej) => {
    xhr.onreadystatechange = () => {
      if (xhr.readyState === XMLHttpRequest.DONE) {
        return res(JSON.parse(xhr.response))
      }
    }

    xhr.addEventListener('error', err => rej(err))
    xhr.open('GET', url, true)
    xhr.setRequestHeader('Accept', 'application/json')
    xhr.setRequestHeader('Content-Type', 'application/json')
    xhr.send()
  })
}
